import * as React from 'react';

import { Button } from 'components/Button';
import { Dialog } from 'components/Dialog';

import './Confirmation.scss';

interface ConfirmationProps {
  actionNoHandler: MSExecAtPriorityFunctionCallback;
  actionNoText: string | JSX.Element;
  actionYesHandler: MSExecAtPriorityFunctionCallback;
  actionYesText: string | JSX.Element;
  isOpen: boolean;
  onOverlayClick?: MSExecAtPriorityFunctionCallback;
  title: string | JSX.Element;
}

export class Confirmation extends React.Component<ConfirmationProps, {}> {
  render() {
    const { actionNoHandler, actionNoText, actionYesHandler, actionYesText, children, isOpen, onOverlayClick, title } = this.props;
    return (
      <Dialog className="confirmation__dialog" onOverlayClick={onOverlayClick} isOpen={isOpen}>
        <h3 className="confirmation__title u-heavy">{title}</h3>
        <div className="o-footnote-1">{children}</div>
        <div className="confirmation__action">
          <Button type="button" className="button--white confirmation__action-button--yes" onClick={actionYesHandler}>{actionYesText}</Button>
          <Button type="button" className="button--white confirmation__action-button--no" onClick={actionNoHandler}>{actionNoText}</Button>
        </div>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Confirmation/Confirmation.tsx